var exports = {
  "u": "x7be19a29--418503--filters",
  "v": "x7be19a29--418503--tabs",
};

module.exports = exports;
